const others = {
  param: 'Parámetros',
  message: 'Siempre que tengamos alguna novedad, ¡te mantendremos informado(a) por aquí!',
  matchTrue: 'Seleccione una de las opciones en la lateral para comenzar.',
  matchFalse: 'Seleccione una de las siguientes opciones para comenzar.',
  infoLabel: 'Últimos avisos',
  infoMsg: 'sin avisos por el momento'
}

export default others;
